import generateRender from 'shared/utils/generateRender';
import StreakDaysRowDefault from './StreakDaysRowDefault';

const StreakDaysRow = generateRender({
  default: StreakDaysRowDefault,
});

export default StreakDaysRow;

